module.exports = __webpack_public_path__ + "static/media/ky.cdb2b536.svg";